import styled from 'styled-components';

export const DashboardToolbar = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 1rem 2rem 0;
`;

export const DashboardGrid = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 2rem 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const IntroCard = styled.section`
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  background:
    radial-gradient(
      circle at top right,
      ${({ theme }) => `${theme.colors.primary}16`} 0%,
      transparent 55%
    ),
    ${({ theme }) => theme.colors.background};
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.08);
  padding: 1.25rem 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const IntroTitle = styled.h2`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const IntroBody = styled.p`
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const IntroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  align-items: center;
`;

export const SectionHeading = styled.h3`
  font-size: 0.95rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const SectionPeriod = styled.p`
  font-size: 0.78rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const SectionHint = styled.p`
  margin: 0 0 0.65rem;
  font-size: 0.82rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;
